import * as React from "react";
const SvgChariot = props => <svg width={1024} height={1024} viewBox="0 0 270.93334 270.93334" id="svg5" xmlSpace="preserve" {...props}><defs id="defs2" /><g id="layer2" style={{
    display: "inline"
  }} transform="translate(-11.038231)"><g id="g10173" style={{
      display: "inline"
    }}><path style={{
        opacity: 1,
        fill: "#f2f2f2",
        fillOpacity: 1,
        stroke: "#ececec",
        strokeWidth: 20,
        strokeLinecap: "round",
        strokeDasharray: "none",
        strokeOpacity: 1
      }} d="M 194.86563,139.03853 C 182.63592,117.40802 175.60005,91.053342 184.94375,73.289582" id="path9387" /><path style={{
        display: "inline",
        opacity: 1,
        fill: "#f2f2f2",
        fillOpacity: 1,
        stroke: "none",
        strokeWidth: 15,
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeDasharray: "none"
      }} d="m 213.23431,52.291282 -1.63703,-25.210197 -16.32349,-5.846521 -13.98487,3.788544 -9.77539,10.33665 -1.77734,12.207536 4.81753,13.610701 1.29208,3.806085 c 0,0 12.42854,-3.143336 15.68622,-1.373935 0,0 18.33469,9.915701 16.51057,4.817534 L 205.47013,55.23793 c 0,0 7.85772,3.27405 7.76418,-2.946648 z" id="path15317" /><path style={{
        display: "inline",
        opacity: 1,
        fill: "#008080",
        stroke: "#e6e6e6",
        strokeWidth: 20,
        strokeLinecap: "round",
        strokeLinejoin: "miter",
        strokeDasharray: "none"
      }} d="M 241.43229,112.31563 C 219.13774,109.22864 198.77167,96.484823 184.94375,73.289582" id="path9443" /><path style={{
        display: "inline",
        opacity: 1,
        fill: "none",
        stroke: "#999999",
        strokeWidth: 15,
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeDasharray: "none"
      }} d="m 219.24037,25.499219 c -29.73981,-18.9506796 -59.18979,-3.98972 -51.68326,34.241094 0.13846,0.705143 0.28948,1.418203 0.45331,2.139113" id="path10179" /><path style={{
        display: "inline",
        opacity: 1,
        fill: "#999999",
        stroke: "none",
        strokeWidth: 15,
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeDasharray: "none"
      }} d="m 153.91204,74.163919 c 0,0 14.18143,1.353855 21.95357,-9.179869 -0.19844,-18.024739 -16.94163,-14.618283 -16.94163,-14.618283 1.34261,16.290039 -5.01194,23.798152 -5.01194,23.798152 z" id="path15435" /></g><path style={{
      display: "inline",
      fill: "#898989",
      strokeWidth: 0.438215
    }} d="M 104.94103,0.01505568 94.752027,33.004854 110.2327,44.398747 Z m 0,0 17.6596,29.66953032 -12.36793,14.714161 z" id="use699" /><path style={{
      display: "inline",
      fill: "#898989",
      strokeWidth: 0.438215
    }} d="m 56.762736,10.799096 -2.295114,34.451052 17.693463,7.510891 z m 0,0 24.033959,24.789339 -8.63561,17.172604 z" id="use699-1" /><path style={{
      display: "inline",
      fill: "#898989",
      strokeWidth: 0.438215
    }} d="m 21.43064,52.111544 6.630291,33.884831 19.029014,2.714539 z m 0,0 29.594611,17.784868 -3.935306,18.814502 z" id="use699-1-6" /><rect style={{
      display: "inline",
      fill: "#4d4d4d",
      stroke: "none",
      strokeWidth: 0.264583
    }} id="use767" width={9.915699} height={149.48386} x={100.28105} y={52.428131} transform="rotate(-5.6355922)" /><rect style={{
      display: "inline",
      fill: "#4d4d4d",
      stroke: "none",
      strokeWidth: 0.264583
    }} id="use767-6" width={9.915699} height={149.48386} x={44.118816} y={72.370888} transform="rotate(-20.737417)" /><rect style={{
      display: "inline",
      fill: "#4d4d4d",
      stroke: "none",
      strokeWidth: 0.264583
    }} id="use767-6-0" width={9.915699} height={149.48386} x={-19.661316} y={96.809654} transform="rotate(-36.481806)" /><path style={{
      display: "inline",
      fill: "#e6e6e6",
      strokeWidth: 0.264583
    }} d="m 83.254457,237.7897 37.978993,-88.49294 128.15574,-24.69571 c 24.07705,5.89641 0.69199,92.73346 -6.17392,127.78156 z" id="path813" /><g id="g23412"><circle style={{
        opacity: 1,
        fill: "none",
        stroke: "#ffffff",
        strokeWidth: 8.99756,
        strokeDasharray: "none"
      }} id="path1083" cx={173.50133} cy={215.75554} r={49.873661} /><circle style={{
        fill: "none",
        stroke: "#ffffff",
        strokeWidth: 8.99756,
        strokeDasharray: "none"
      }} id="circle1109" cx={173.50133} cy={215.75554} r={14.521684} /><circle style={{
        fill: "#ffffff",
        stroke: "#ffff00",
        strokeWidth: 0.0201698
      }} id="path1083-8" cx={173.50133} cy={215.75554} r={4.2255702} /><g id="g9261" style={{
        display: "inline",
        stroke: "#ffffff"
      }} transform="matrix(0.89975595,0,0,0.89975595,17.333659,22.212395)"><path style={{
          opacity: 1,
          fill: "#ff0000",
          stroke: "#ffffff",
          strokeWidth: 10,
          strokeDasharray: "none"
        }} d="M 228.6,215.10625 H 190.63229" id="path4832" /><path style={{
          opacity: 1,
          fill: "#ff0000",
          stroke: "#ffffff",
          strokeWidth: 10,
          strokeDasharray: "none"
        }} d="M 173.56666,270.13958 V 232.17187" id="path9242" /><path style={{
          opacity: 1,
          fill: "#ff0000",
          stroke: "#ffffff",
          strokeWidth: 10,
          strokeDasharray: "none"
        }} d="m 118.53333,215.10624 h 37.96771" id="path9244" /><path style={{
          opacity: 1,
          fill: "#ff0000",
          stroke: "#ffffff",
          strokeWidth: 10,
          strokeDasharray: "none"
        }} d="m 134.65223,176.1918 26.84722,26.84722" id="path9246" /><path style={{
          opacity: 1,
          fill: "#ff0000",
          stroke: "#ffffff",
          strokeWidth: 10,
          strokeDasharray: "none"
        }} d="m 212.48111,176.19181 -26.84722,26.84722" id="path9248" /><path style={{
          display: "inline",
          opacity: 1,
          fill: "#ff0000",
          stroke: "#ffffff",
          strokeWidth: 10,
          strokeDasharray: "none"
        }} d="M 212.4811,254.02069 185.63388,227.17347" id="path9250" /><path style={{
          display: "inline",
          opacity: 1,
          fill: "#ff0000",
          stroke: "#ffffff",
          strokeWidth: 10,
          strokeDasharray: "none"
        }} d="m 134.65222,254.02068 26.84722,-26.84722" id="path9252" /><path style={{
          opacity: 1,
          fill: "#ff0000",
          stroke: "#ffffff",
          strokeWidth: 10,
          strokeDasharray: "none"
        }} d="m 173.56667,160.07291 v 37.96771" id="path3368" /></g></g></g></svg>;
export { SvgChariot as ReactComponent };